import { cn } from '@/lib/utils';
import { ChevronRight } from 'lucide-react';

interface SelectionBarProps {
  count: number;
  onReviewOrder: () => void;
  className?: string;
}

export function SelectionBar({ count, onReviewOrder, className }: SelectionBarProps) {
  if (count === 0) return null;

  return (
    <div
      className={cn(
        'fixed bottom-6 left-1/2 -translate-x-1/2 z-50',
        'animate-fade-in',
        className
      )}
    >
      <div className="flex items-center gap-1 bg-slate-900 text-white rounded-full shadow-xl px-2 py-2">
        {/* Count badge */}
        <div className="flex items-center gap-2 pl-3 pr-4">
          <span className="flex items-center justify-center w-6 h-6 bg-indigo-500 text-white text-sm font-semibold rounded-full">
            {count}
          </span>
          <span className="text-sm font-medium">
            Number{count !== 1 ? 's' : ''} Selected
          </span>
        </div>

        {/* Divider */}
        <div className="w-px h-6 bg-slate-700" />

        {/* Review Order button */}
        <button
          onClick={onReviewOrder}
          className="flex items-center gap-1 px-4 py-2 bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-400 hover:to-purple-400 text-white text-sm font-medium rounded-full transition-all"
        >
          Review Order
          <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );
}
